import {createReducer} from '@reduxjs/toolkit'
import {
    dZReportsCheckedAllItemAC,
    dZReportsCheckedItemAC,
    dZReportsClearFiltersAC,
    dZReportsSetDataAC,
    dZReportsSetDetailItemAC,
    dZReportsSetFiltersAC,
    dZReportsSetItemsForPageAC,
    dZReportsSetPageNumberAC,
    dZReportsSetPaginationAC
} from './dZreportsActionCreators';

import {typePagination} from '../system/constants';
import {logoutAC, resetReducers} from 'model/system/systemActionCreators';


// Type
export type IdZreportsStateDataItem = {

    checked: boolean,
    id: string,
    fiscalCardId: string,
    tin: string,
    zreportNumber: number,
    openDate: string,
    closeDate: string,
    firstReceiptNumber: number,
    lastReceiptNumber: number,
    salesWithCash: string,
    salesWithCards: string,
    vatAmount: string,
    salesCount: number,
    returnWithCash: string,
    returnWithCards: string,
    vatReturnAmount: string,
    returnCount: number,
    merchantName: string,
    merchantAddress: string,
    terminalSerianNumber: string,
    userId: string,
    userName: string,
    cashierId: string,
    store: {
        "address": "string",
        "deleted": true,
        "description": "string",
        "email": "string",
        "id": "string",
        "industry": {
            "id": "string",
            "name": "string"
        },
        "manager": "string",
        "managerPhoneNumber": "string",
        "name": "string",
        "phoneNumber": "string"
    },
    softwareVersion: "string"
}

export type typeZreportsFilters = {
    closeDate?: {
        from: string | null,
        to: string | null
    } | null,
    fiscalCardId?: string | null,
    terminalSerianNumber?: string | null,
    storeId?: string | null
    userName?: string | null

}
export type IdZreportsState = {
    pagination: typePagination,
    data: IdZreportsStateDataItem[],
    detailItem: IdZreportsStateDataItem | undefined,
    filters: typeZreportsFilters
}


// Init state
export const initialState: IdZreportsState = {
    pagination: {
        pageNumber: 0,
        itemsPerPage: 14,
    },
    data: [],
    detailItem: undefined,
    filters: {
        closeDate: null,
        storeId: null,
        userName:null,
        fiscalCardId: null,
        terminalSerianNumber: null

    }
}


// Reducer
export const DZreportsReducer = createReducer(initialState, builder => {
    builder

        // Reducer of set data
        .addCase(dZReportsSetDataAC, (state, action) => {
            state.data = action.payload.dataList
        })

        // Reducer of set pagination
        .addCase(dZReportsSetPaginationAC, (state, action) => {
            state.pagination = {...state.pagination, ...action.payload.pagination}
        })

        // Reducer of set items for page pagination
        .addCase(dZReportsSetItemsForPageAC, (state, action) => {
            state.pagination = { ...state.pagination,pageNumber:0, itemsPerPage: action.payload.itemsForPage }
        })

        // Reducer of set pageNumber pagination
        .addCase(dZReportsSetPageNumberAC, (state, action) => {
            state.pagination.pageNumber = action.payload.pageNumber
        })

        // Reducer of set detail item
        .addCase(dZReportsSetDetailItemAC, (state, action) => {
            state.detailItem = state.data.find((item) => item.id === action.payload)
        })

        // Reducer of set checked item
        .addCase(dZReportsCheckedItemAC, (state, action) => {
            state.data = state.data.map(item => {
                if (item.id === action.payload) {
                    const newItem = item
                    newItem.checked = !item.checked
                    return newItem
                } else {
                    return item
                }
            })
        })

        // Reducer of set checked all items
        .addCase(dZReportsCheckedAllItemAC, (state, action) => {
            state.data = state.data.map(item => {
                const newItem = item
                newItem.checked = action.payload
                return newItem
            })
        })

        // Reducer of clear filtersForm
        .addCase(dZReportsClearFiltersAC, (state) => {
            state.filters.closeDate = null
            state.filters.terminalSerianNumber = null
            state.filters.fiscalCardId = null
            state.filters.userName = null
            state.filters.storeId = null
        })

        // Reducer of set filtersForm
        .addCase(dZReportsSetFiltersAC, (state, action) => {
            state.filters = {...state.filters, ...action.payload}
            state.pagination.pageNumber = 0

        })
        // Reducer of clear state
        .addCase(logoutAC, ( state ) => {
            state.data = initialState.data
            state.detailItem=initialState.detailItem
            state.filters = initialState.filters
            state.pagination = initialState.pagination
        })

        .addCase(resetReducers, (state, action) => {
            if (action.payload !== "closing-z-reports") {
                state.data = initialState.data
                state.detailItem=initialState.detailItem
                state.filters = initialState.filters
                state.pagination = initialState.pagination
            }
        });
})

